import React from 'react';
import './BlogsComponent.css'
import { useLocation, useNavigate } from 'react-router-dom';

const BlogsReadMore = () => {
    const location = useLocation();
    const blogData = location.state;
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate('/Blogs');
    };

    return (
        <div style={{ flex: 1 }}>
            <div className="blog_details_wrapper">
                <a
                    href="#"
                    className="go-back-link"
                    onClick={handleGoBack}
                    style={{ cursor: 'pointer', fontSize: '18px', color: '#007bff', textDecoration: 'none', marginBottom: '20px' }}
                >
                    ← Go Back to All Blogs
                </a>
                <div className="blog-post-details-container">
                    <div className="blog-post-image-wrapper">
                        <img
                            src='/image/no-product-img-700.jpg'
                            alt="Blog Post"
                            onError={(e) => { e.target.onerror = null; e.target.src = '/image/no-product-img-700.jpg'; }}
                            className="blog-post-image"
                        />
                    </div>
                    <div className="blog-post-content-wrapper">
                        <h1 className="blog-post-title">{blogData?.Title}</h1>
                        <h3 className="blog-post-subtitle">{blogData?.Description}</h3>
                        <div className="blog-post-details">
                            <div dangerouslySetInnerHTML={{ __html: blogData?.Details }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default BlogsReadMore;
